import { createContext } from 'react';

export const SignInContext = createContext<{
  setShowSignInModal: (isShow: boolean) => void;
  userEmail: string | null;
  setUserEmail: (email: string) => void;
  externalUserId: string | null;
  setExternalUserId: (id: string) => void;
  firstName: string | null;
  lastName: string | null;
  dateOfBirth: string | null;
  setFirstName: (firstName: string) => void;
  setLastName: (lastName: string) => void;
  setDateOfBirth: (date: string) => void;
}>({
  setShowSignInModal: () => {},
  userEmail: null,
  setUserEmail: () => {},
  externalUserId: null,
  setExternalUserId: () => {},
  firstName: null,
  lastName: null,
  dateOfBirth: null,
  setFirstName: () => {},
  setLastName: () => {},
  setDateOfBirth: () => {},
});
